import ConfirmDeleteModalUI from '@/components/common/ConfirmDeleteModalUI/ConfirmDeleteModalUI'
import { useConfigUI } from '@/features/config/context'
import { debounce } from 'lodash'
import useTranslation from '@/hooks/useTranslation'
import { IFormCisFertigationMode } from '@/types/cisFertigation'
import useUpdateCisFertigationMode from '@/features/config/hooks/cisFertigation/useUpdateCisFertigationMode'

interface UpdateModalProps {
  pipeId?: string
  interfaceId?: string
  fertigationMode?: string
}

const UpdateCisFertigationModal = ({ pipeId, interfaceId, fertigationMode }: UpdateModalProps) => {
  const { t } = useTranslation()
  const { closeModal } = useConfigUI()
  const { mutate: editFertigationMode, isLoading: loadingUpdate } =
    useUpdateCisFertigationMode()

  const handleUpdateModeFertigation = debounce(async () => {
    if (!pipeId) return
    const formData: IFormCisFertigationMode = {
      interfaceId: interfaceId!,
      pipeId: pipeId!,
      fertigationMode: fertigationMode,
    }
    editFertigationMode(formData)
  }, 300)

  return (
    <ConfirmDeleteModalUI
      title={t('updateFertigationModeTitle')}
      text={t('fertigationUpdateModeConfirmation', {mode: (fertigationMode == '1')? t('fertigationParallel'): t('fertigationSerial')})}
      onClose={closeModal}
      onConfirm={handleUpdateModeFertigation}
      isLoading={loadingUpdate}
    />
  )
}

export default UpdateCisFertigationModal
